import client from './client';
import Cookies from 'js-cookie';

// Relative by default so it works same-origin in production regardless of
// domain (matches the pattern used in api/client.js and JourneyPage.jsx).
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// Persist a stable guest id so anonymous visitors can resume their conversations.
function getGuestId() {
  let id = localStorage.getItem('chat_guest_id');
  if (!id) {
    id = 'g_' + (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now());
    localStorage.setItem('chat_guest_id', id);
  }
  return id;
}

function authHeaders() {
  const headers = { 'x-guest-id': getGuestId() };
  const token = Cookies.get('token');
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

export const chatAPI = {
  getConfig: () => client.get('/chat/config', { headers: { 'x-guest-id': getGuestId() } }),

  listConversations: () => client.get('/chat/conversations', { headers: authHeaders() }),

  getConversation: (id) =>
    client.get(`/chat/conversations/${id}`, { headers: authHeaders() }),

  deleteConversation: (id) =>
    client.delete(`/chat/conversations/${id}`, { headers: authHeaders() }),

  // Non-streaming send
  sendMessage: (message, conversationId, model) => {
    const url = conversationId
      ? `/chat/conversations/${conversationId}/messages`
      : '/chat/messages';
    return client.post(url, { message, model }, { headers: authHeaders() });
  },

  /**
   * Streaming send over Server-Sent Events. Uses fetch (axios in the browser
   * cannot stream incrementally). Calls callbacks for each lifecycle event.
   */
  streamMessage: async (message, conversationId, model, { language, onMeta, onDelta, onDone, onError }) => {
    const url = conversationId
      ? `${API_BASE_URL}/chat/conversations/${conversationId}/stream`
      : `${API_BASE_URL}/chat/stream`;

    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ message, model, language })
      });

      if (!res.ok || !res.body) {
        const data = await res.json().catch(() => ({}));
        onError?.(data.message || 'خطا در ارتباط با دامبلدور');
        return;
      }

      const reader = res.body.getReader();
      const decoder = new TextDecoder('utf-8');
      let buffer = '';

      // eslint-disable-next-line no-constant-condition
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });

        const events = buffer.split('\n\n');
        buffer = events.pop();
        for (const block of events) {
          const lines = block.split('\n');
          let event = 'message';
          let data = '';
          for (const line of lines) {
            if (line.startsWith('event:')) event = line.slice(6).trim();
            else if (line.startsWith('data:')) data += line.slice(5).trim();
          }
          if (!data) continue;
          let parsed;
          try { parsed = JSON.parse(data); } catch { continue; }
          if (event === 'meta') onMeta?.(parsed);
          else if (event === 'delta') onDelta?.(parsed.text);
          else if (event === 'done') onDone?.(parsed);
          else if (event === 'error') onError?.(parsed.message);
        }
      }
    } catch (err) {
      onError?.(err.message || 'خطا در ارتباط با دامبلدور');
    }
  }
};
